import React, {useEffect, useState} from 'react';
import {Box, Button, Stack, Text} from '@chakra-ui/react';
import News from './Podcasts/news';
import All from './Podcasts/all';
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import Container from "../../../components/Container";

const Podcasts = () => {
    const [, setIsLoading] = useState(false)
    const {pageCount} = useParams();
    const [startIndex, setStartIndex] = useState(pageCount || 0)
    const [podcastType, setPodcastType] = useState('all')
    const [, setPodcastData] = useState(undefined)
    const [allData, setAllData] = useState(undefined)
    const [showPodcastsButton, setShowPodcastsButton] = useState(false)
    const navigate = useNavigate();
    const {slug} = useParams();

    useEffect(() => {
        const fetchAllPodcastData = async () => {
            const allData = await axios.get(`/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=yes&team_slug=${slug}`).then(resp => {
                return resp.data;
            });
            const podcastData = await axios.get(`/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=only&team_slug=${slug}`).then(resp => {
                return resp.data;
            });
            setShowPodcastsButton(podcastData?.length > 0)
            setAllData(allData)
        }
        fetchAllPodcastData()
    }, [slug, startIndex])


    useEffect(() => {
        const endpoints = {
            all: `/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=yes&team_slug=${slug}`,
            podcast: `/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=only&team_slug=${slug}`,
            perspectives: `/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=no&team_slug=${slug}`
        }
        const fetchPodcastData = async () => {
            setIsLoading(true)
            const response = await axios.get(endpoints[podcastType]).then(resp => {
                return resp.data;
            });
            setPodcastData(response)
            setIsLoading(false)
        }
        fetchPodcastData()
    }, [slug, podcastType])


    return (
        <Box borderX={'1px'} borderColor={'brandAlpha.200'} as="section">
            <Box px={['2.5', '5']}>
                <Container>
                    {allData?.length > 0 &&
                        <Text
                            pb={'40px'}
                            as={'h1'}
                            lineHeight={'2rem'}
                            textAlign={'left'}
                            fontSize={'2rem'}
                        >
                            Latest
                        </Text>
                    }
                    <Box textAlign={'left'}>
                        <Box pb={'120px'}>
                            <Stack
                                spacing="16"
                                height={'100%'}
                                alignSelf={'stretch'}
                                direction={{base: 'column', md: 'row'}}
                            >
                                {allData?.length > 0 &&
                                    <>
                                        <Box alignSelf={'stretch'} width="full" height={'100%'}>
                                            <Text
                                                borderRight={{base: 'none', md: '1px solid #A1B6E5'}}
                                                pb={'40px'}
                                                as={'h2'}
                                                lineHeight={'18px'}
                                                textAlign={'left'}
                                                fontSize={'lg'}
                                            >
                                                Podcast & Perspectives
                                            </Text>
                                            <Box borderRight={{base: 'none', md: '1px solid #A1B6E5'}} pb={'50px'}>
                                                <Button isActive={podcastType === 'all'}
                                                        onClick={() => {
                                                            setStartIndex(0)
                                                            navigate(`/teammember/${slug}`)
                                                            setPodcastType('all')
                                                        }}>All</Button>
                                                {showPodcastsButton &&
                                                    <Button isActive={podcastType === 'podcast'}
                                                            onClick={() => {
                                                                setStartIndex(0)
                                                                navigate(`/teammember/${slug}`)
                                                                setPodcastType('podcast')
                                                            }}>Podcast</Button>
                                                }
                                                <Button isActive={podcastType === 'perspectives'}
                                                        onClick={() => {
                                                            navigate(`/teammember/${slug}`)
                                                            setPodcastType('perspectives')
                                                        }}>Perspectives</Button>
                                            </Box>
                                            <All podcastType={podcastType} startIndex={startIndex} setStartIndex={setStartIndex} pageCount={pageCount}/>
                                        </Box>

                                        <Box
                                            alignSelf={'stretch'}
                                            marginLeft={{base: 'none', md: 'auto !important'}}
                                            width={{base: 'full', md: '410px'}}
                                            height={'100%'}
                                        >
                                            <News/>
                                        </Box>
                                    </>
                                }
                            </Stack>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};
export default Podcasts;
